<button type="button" class="btn btn-primary SCAcustomBtn">Filter</button>  

<!-- <app-grid-view #gv1></app-grid-view> -->

<!-- <app-grid-view #gv2></app-grid-view> -->

<app-grid-view #gvTest></app-grid-view>